module.exports = __webpack_public_path__ + "static/Young-Adults-Guide__Chapter-1-7a2c0e2dd1fd40b0aacef94ff3646ae3.pdf";